module.exports = __webpack_public_path__ + "static/media/Apple Macbook Pro 13\" Space Grey.f5227fe1.png";